import React, { createContext, useContext, useRef, useCallback, useMemo } from 'react';

const PixelContext = createContext();

export const usePixelManager = () => {
  const context = useContext(PixelContext);
  if (!context) {
    throw new Error('usePixelManager must be used within a PixelProvider');
  }
  return context;
};

export const PixelProvider = ({ children }) => {
  const pixelManagerRef = useRef(null);

  const setPixelManager = useCallback((manager) => {
    pixelManagerRef.current = manager;
  }, []);

  const forceConnectionTest = useCallback(async () => {
    if (pixelManagerRef.current?.forceConnectionTest) {
      return await pixelManagerRef.current.forceConnectionTest();
    }

    throw new Error('PixelManager not available');
  }, []);

  const pairPixel = useCallback(async (characterId) => {
    if (pixelManagerRef.current?.pairPixel) {
      return await pixelManagerRef.current.pairPixel(characterId);
    }

    throw new Error('PixelManager not available');
  }, []);

  const value = useMemo(() => ({
    setPixelManager,
    forceConnectionTest,
    pairPixel,
  }), [setPixelManager, forceConnectionTest, pairPixel]);

  return (
    <PixelContext.Provider value={value}>
      {children}
    </PixelContext.Provider>
  );
};